var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaknlLgBed = function SvgVaknlLgBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#282828",
    fillRule: "nonzero",
    transform: "translate(7 25)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 5.807,
    x: 0.273,
    y: 0.097,
    rx: 2.384,
    transform: "rotate(-90 3.273 3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 5.807,
    x: 19.729,
    y: 0.097,
    rx: 2.384,
    transform: "rotate(-90 22.729 3)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3D9B8B",
    fillRule: "nonzero",
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.25 21.5h31.5v3.574a2.43 2.43 0 0 1-2.426 2.426H6.676a2.426 2.426 0 0 1-2.426-2.426V21.5zm27.75-1v-9.314A2.145 2.145 0 0 0 29.913 9H10.087A2.145 2.145 0 0 0 8 11.186V20.5h24z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F3AD05",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(6 14)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 6,
    y: 0.5,
    rx: 2.898
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 6,
    x: 14,
    y: 0.5,
    rx: 2.898
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M6.676 18.167h26.648a2.434 2.434 0 0 1 2.426 2.426v.9H4.25v-.9a2.434 2.434 0 0 1 2.426-2.426z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 20.5h30"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.676 18.167h26.648a2.434 2.434 0 0 1 2.426 2.426v.9H4.25v-.9a2.434 2.434 0 0 1 2.426-2.426z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#288374",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.754 26H35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.25 21.5h31.5v3.574a2.43 2.43 0 0 1-2.426 2.426H6.676a2.426 2.426 0 0 1-2.426-2.426V21.5z"
  }))));
};
export default SvgVaknlLgBed;